import React, {Component} from "react";
import {
	Box,
	Grid,
	Button,
	Skeleton,
	Container
} from "@mui/material";
import {
	FilterType,
	ItemCard
} from "./components";
import {
	HeadTitleGoBack, LoadingContent,
	VisibleContent
} from "../../../components";
import {
	FeaturedPlayList
} from "@mui/icons-material";
import agent from "../../../agent/agent";
import getTrans from "../../../languages/getTrans";

class BalanceHistory extends Component {
	constructor(props) {
		super(props);

		this.state = {
			items: [],
			filter: {
				type: "incoming",
				page: 1
			},

			isLoading: true,
			isShowMore: false,
		};
	}

	componentDidMount = async () => {
		await this.getItems();
	}

	getItems = async ({ isMore } = {}) => {
		await this.setState({ isLoading: true });
		const filter = this.getFilter();
		const res = await agent.get(`/api/sms-users/get-transactions${ filter }`).then((res) => {
			return res?.data || []
		}).catch(() => {
			return []
		});

		let items = [];
		if (isMore) {
			items = [...(this.state?.items || [])]
		}

		await this.setState({
			items: [...items, ...res],
			isLoading: false,
			isShowMore: Boolean(res.length === 20)
		});
	}
	loadMoreItems = async () => {
		const filter = {...this.state.filter};
		filter.page = filter.page + 1;
		await this.setState({ filter });
		await this.getItems({ isMore: true })
	}

	getFilter = () => {
		const { filter } = this.state;

		let _str = [];
		Object.keys(filter).map((_key) => {
			let _val = filter[_key];
			if (_val) {
				_str.push(`${ _key }=${ _val }`);
			}
		})

		return `?${ _str.join('&') }`
	}
	changeFilter = async (filter) => {
		await this.setState({
			items: [],
			filter
		});
		await this.getItems();
	}

	render() {
		const {
			items,
			filter,
			isLoading,
			isShowMore,
		} = this.state;

		return (
			<Container>
				<HeadTitleGoBack title={getTrans('history.История баланса')} isGoBack={true} Icon={FeaturedPlayList} />
				<FilterType filter={filter} onChange={this.changeFilter}/>
				<VisibleContent visible={!isLoading}>
					<Container sx={{height: "calc(100vh - 140px)", overflow: "auto", padding: "0", marginBottom: "-78px", paddingBottom: "78px"}}>
						<Grid container spacing={1}>
							{items.map((item, index) => (
								<Grid key={`item-${item.id}`} item xs={12}>
									<ItemCard item={item}/>
								</Grid>
							))}
						</Grid>
					</Container>
				</VisibleContent>
				<VisibleContent visible={isLoading}>
					<LoadingContent removeBg/>
				</VisibleContent>
			</Container>
		);
	}
}

export default BalanceHistory
